<template>
  <div id="app" data-app=true>
    <AppHeader />
    <router-view/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';

export default {
  name: 'app',
  components: {
    AppHeader,
  },
};
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.form-input {
  label {
    font-weight: lighter;
  }
}
div.input-group__input {
  border-bottom: 1px solid black;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue